export const boatTypeConstants = {
  BOAT_TYPE_DATA: "BOAT_TYPE_DATA",
  BOAT_TYPE_UNOFFICIAL_DATA: "BOAT_TYPE_UNOFFICIAL_DATA",
  SPINNER: "SPINNER",
  GET_SPINNER: "GET_SPINNER",
  BOAT_CLASS_DATA: "BOAT_CLASS_DATA",
  BOAT_CLASS_DATA_BY_ID: "BOAT_CLASS_DATA_BY_ID",
  GET_ALL_GENDER_BOAT_CLASS_DATA: "GET_ALL_GENDER_BOAT_CLASS_DATA",
};
